module.exports = __webpack_public_path__ + "assets/img/6b42f1706b67ca33238fb233a45f3c82.svg";